<div
  class="flex h-full items-center"
  [class.flex-row-reverse]="params.rowReverse"
  [class.justify-center]="params.justifyCenter"
  [class.justify-end]="params.rightAlignment"
>
  @for (icon of params.icons; track icon.icon) {
    @if (icon.showIcon) {
      <aux-icon
        [name]="icon.icon"
        [class]="'min-w-[24px] ' + icon.iconClass"
        [ngClass]="{
          'mr-[5px]': !params.rowReverse && !params.hideText,
          'ml-[5px]': params.rowReverse && !params.hideText,
        }"
        [class.cursor-pointer]="!icon.iconDisabled && icon.iconClick"
        [class.opacity-50]="icon.iconDisabled"
        [class.cursor-not-allowed]="icon.iconDisabled"
        [template]="
          icon.iconTooltipMessages && icon.iconTooltipMessages.length > 1
            ? iconErrorArrayTooltip
            : undefined
        "
        [auxTooltip]="
          icon.iconTooltipMessages && icon.iconTooltipMessages.length === 1
            ? icon.iconTooltipMessages[0]
            : ''
        "
        (click)="onIconClick(icon)"
      />
    }

    <ng-template #iconErrorArrayTooltip>
      <aux-errors-tooltip [errors]="icon.iconTooltipMessages" />
    </ng-template>
  }
  @if (!params.hideText) {
    <span
      #text
      class="truncate"
      [class.flex-1]="!params.rightAlignment"
      [class.aux-link]="params.textClick && params.value"
      [class.aux-link-zero-hyphen]="params.textClick && !params.value"
      [class.cursor-pointer]="params.textClick"
      [class.opacity-50]="params.textDisabled"
      [class.!cursor-not-allowed]="params.textDisabled"
      [template]="
        params.textTooltipMessages && params.textTooltipMessages.length > 1
          ? textErrorArrayTooltip
          : undefined
      "
      [auxTooltip]="textTooltip(text.offsetWidth, text.scrollWidth)"
      (click)="onTextClick()"
    >
      {{ value }}
    </span>

    <ng-template #textErrorArrayTooltip>
      <aux-errors-tooltip [errors]="params.textTooltipMessages || []" />
    </ng-template>
  }
</div>
